import { create } from "zustand";
import { FetchState, ignore } from "./util";

/** Een officiële bekendmaking uit het register van de omgevingsmonitor. */
export type Publicatie = {
  publicatieId: string;
  titel: string;
  url: string;
  soort: string;
  blad: string;
  creator: string;
  gemeente: string;
  gepubliceerdOp: string | null;
  geometrielabel: string;
  afstandMeter: number | null;
  /** Individuele toestemming of beleid. De monitor bepaalt dat, niet wij. */
  vergunning: boolean;
};

interface PublicatiesState {
  state?: FetchState;
  projectId?: number;
  publicaties?: Publicatie[];
  load: (projectId: number, force?: boolean) => void;
  clear: () => void;
}

/**
 * Los van de cube: die komt uit ca_reference en wordt per project gecachet,
 * dit komt uit de omgevingsmonitor en verandert dagelijks. Ze samenvoegen zou
 * betekenen dat een nieuwe bekendmaking pas zichtbaar wordt als de hele cube
 * ververst.
 */
export const usePublicaties = create<PublicatiesState>((set, get) => ({
  load: async (projectId: number, force?: boolean) => {
    const cur = get();
    if (!force && cur.projectId === projectId && cur.state === "fetched") return;
    set({ projectId, state: "fetching", publicaties: undefined });
    const response: Response = await fetch(`/api/projects/${projectId}/publicaties`).catch(ignore);
    if (!response.ok) return set({ projectId, state: "error" });
    const data = await response.json();
    // Een ander project geselecteerd terwijl dit antwoord onderweg was.
    if (get().projectId === projectId) set({ state: "fetched", publicaties: data });
  },
  clear: () => set({ state: undefined, projectId: undefined, publicaties: undefined }),
}));
